import s from './SelectProposalTemplateClients.scss'
import { Container, Row, Col } from 'reactstrap'
import { Checkbox, KeyValuePairs } from 'components/ideal-core-ui'
import * as ACT from './actions'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'

const SelectProposalTemplateClients = ({
  companies,
  dealId,
  proposalsByClient,
  dispatch,
  clientsProposals,
  baseBid,
  setBaseBid
}) => (
  <>
    <p className={s.subtitle}>
      Below is a list of Clients and Proposals available for each. Choose to create a new proposal
      or replace an existing one. <br /> (if you need to add more clients to this opportunity click{' '}
      <a href={`/opportunities/${dealId}/details`}>here</a>)
    </p>
    <section className={s.baseBidWrapper}>
      <KeyValuePairs
        pairs={[
          {
            key: `Base Bid ${getCurrency().symbol} `,
            keyClass: [s.baseBidLabel],
            value: (
              <NumericFormat
                thousandSeparator
                decimalScale={2}
                value={baseBid}
                prefix={getCurrency().symbol}
                onValueChange={formattedValue => setBaseBid(formattedValue.value)}
                placeholder="Enter Value"
                data-cy="bid_input"
              />
            )
          }
        ]}
      />
      <p className={s.baseBidText}>
        This value is a CRM system value for record only. It does not affect the pricing on your
        proposals, but is used in creating your reports.{' '}
      </p>
    </section>
    <Container className={s.container}>
      <Row>
        <Col sm="12" md={{ size: 6, offset: 3 }}>
          {companies.map(company => {
            const index = clientsProposals.findIndex(c => c.companyId === company.value)
            const isCompanySelected = index !== -1
            const proposalId = index !== -1 ? clientsProposals[index].proposalId : 0

            return (
              <div key={company.value} className={s.company}>
                <Checkbox
                  isChecked={isCompanySelected}
                  triggerCheckbox={() =>
                    dispatch({
                      type: ACT.TOGGLE_CLIENT_ACTION,
                      payload: {
                        companyId: company.value
                      }
                    })
                  }
                />
                <span className={s.companyName} style={{ color: company.color }}>
                  {company.label}
                </span>
                <div className={s.radioGroup}>
                  <input
                    type="radio"
                    checked={
                      isCompanySelected === -1 || (isCompanySelected !== -1 && proposalId === 0)
                    }
                    disabled={!isCompanySelected}
                    onChange={() =>
                      dispatch({
                        type: ACT.CHANGE_PROPOSAL_ACTION,
                        payload: {
                          companyId: company.value,
                          proposalId: 0
                        }
                      })
                    }
                    data-cy="create_new_proposal_radio"
                  />{' '}
                  Create new proposal
                  {Array.isArray(proposalsByClient[company.label]) &&
                    proposalsByClient[company.label].map(proposal => (
                      <p key={proposal.id}>
                        <input
                          type="radio"
                          disabled={!isCompanySelected}
                          checked={proposalId === proposal.id}
                          value={proposal.id}
                          onChange={() =>
                            dispatch({
                              type: ACT.CHANGE_PROPOSAL_ACTION,
                              payload: {
                                companyId: company.value,
                                proposalId: proposal.id
                              }
                            })
                          }
                        />{' '}
                        Replace: {proposal.name}
                      </p>
                    ))}
                </div>
              </div>
            )
          })}
        </Col>
      </Row>
    </Container>
  </>
)

export default SelectProposalTemplateClients
